"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("./middleware/middleware.js");exports.default=e.default;
